import React from 'react';
import { applySizeToProps } from '../utils/applySizeToProps';
import { IconProps } from '../types';

export const IconUpChevronOutline: React.FC<IconProps> = (props) => (
  <svg {...applySizeToProps(props)} xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24"><path fill="currentColor" fillRule="nonzero" d="M22.72 18.308 12 7.588 1.28 18.308a.75.75 0 1 1-1.06-1.06L12 5.467l11.78 11.78a.75.75 0 1 1-1.06 1.06" /></svg>
);
